import { Injectable } from '@angular/core';
import { DerivativeAttachmentDto } from '@interfaces/a-organizar/derivative-attachment';
import { VaultApiService } from '@services/api/vault-api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DerivativeAttachmentService {
  private readonly baseUrl = 'operations/ndf/operation';

  constructor(private apiService: VaultApiService) {}

  /**
   * Upload files as attachments to a derivative operation
   */
  uploadAttachments(operationId: string, files: File[], type?: string): Observable<unknown> {
    const payload: Record<string, unknown> = {
      OperationId: operationId,
      Files: files,
    };

    if (type) {
      payload['Type'] = type;
    }

    return this.apiService.post<unknown>(
      `${this.baseUrl}/attachment`,
      payload,
      true // isMultipart
    );
  }

  /**
   * Get all attachments for an operation
   */
  getAttachments(operationId: string): Observable<DerivativeAttachmentDto[]> {
    return this.apiService
      .get<DerivativeAttachmentDto[] | null>(`${this.baseUrl}/${operationId}/attachments`)
      .pipe(map(response => response || []));
  }

  /**
   * Get download link for an attachment
   */
  getDownloadLink(attachmentId: string): Observable<string | null> {
    return this.apiService.get<string>(`${this.baseUrl}/attachment/${attachmentId}/download-link`);
  }

  /**
   * Download file directly
   */
  downloadFile(operationId: string, attachmentId: string): Observable<Blob | null> {
    return this.apiService.get<Blob>(`${this.baseUrl}/${operationId}/attachment/${attachmentId}`, {
      responseType: 'blob',
    });
  }

  /**
   * Delete an attachment
   */
  deleteAttachment(operationId: string, attachmentId: string): Observable<any> {
    return this.apiService.delete<any>(`${this.baseUrl}/${operationId}/attachment/${attachmentId}`);
  }
}
